import React from "react";
import { Button } from "primereact/button";

const ReportButtonComponent = ({ label, icon, onClick }) => (
  <Button label={label} icon={icon} onClick={onClick} />
);

export default ReportButtonComponent;
